// @flow

import { useSelector } from 'react-redux'

import { getCustomerGuestMode, getActiveSubscriptions } from '@alphaott/app-core/selectors'

import { useOpenPanelTrack } from './openPanel'

export const useAnalyticsTrack = () => {
  const isGuestCustomer = useSelector(getCustomerGuestMode)
  const activeSubscriptions = useSelector(getActiveSubscriptions)

  const trackOpenPanel = useOpenPanelTrack()

  const activeSubscription = activeSubscriptions?.[0]

  return (event: string, properties: Object) => {
    trackOpenPanel(event, {
      ...properties,
      ...(isGuestCustomer && {
        guest: isGuestCustomer,
      }),
      ...(activeSubscription && {
        user_subscription_title: activeSubscription.title,
        user_subscription_duration_period: `${activeSubscription.duration}-${activeSubscription.period}`,
        user_subscription_period: activeSubscription.period,
        user_subscription_duration: activeSubscription.duration,
      }),
    })
  }
}

export default useAnalyticsTrack
